import React from "react";
import { StaffOverrideCamera } from "../camera/StaffOverrideCamera";
import { Alert, Dialog, Box, Typography, DialogTitle, DialogContent } from "@mui/material";
import { IPersonBadge, PaymentOptions } from "../../../common/types";
import CloseIcon from "@mui/icons-material/Close";
import { styles as classes } from "./styles";
import { getItemIndex } from "../../createBadge/personDetails/utils/utils";
import { useTranslation } from "react-i18next";
import { StaffScannerProps } from "../../qr/interfaces";

type Props = {
  badges: IPersonBadge[];
  paymentOptions: PaymentOptions[];
  isScannerOpened: boolean;
  handleClose: () => void;
  handleSuccess: () => void;
} & StaffScannerProps;

const PaymentApproveDialog = ({
  badges,
  paymentOptions,
  isScannerOpened,
  handleClose,
  handleSuccess,
  successOnMount,
  skipUserAccessCheck
}: Props) => {
  const { t } = useTranslation("common");

  return (
    <Dialog sx={classes.dialogContainer} open={isScannerOpened}>
      <DialogTitle sx={classes.dialogTitleContainer}>
        <Typography sx={classes.dialogTitle} variant={"body2"}>
          {t("approvePayment.title")}
        </Typography>
        <CloseIcon color={"primary"} onClick={handleClose} sx={classes.dialogCloseButton} />
      </DialogTitle>
      <Alert sx={classes.dialogAlert} severity={"warning"}>
        {t("approvePayment.alert")}
      </Alert>
      <DialogContent>
        <Box>
          {paymentOptions.map((column, index) => {
            const options = Object.values(column);
            return (
              <Box sx={classes.dialogContentTable} key={index}>
                {options.map((optionColumn, idx) => {
                  return (
                    <Box key={idx} sx={classes[`dialogContentTableColumn${getItemIndex(options.length, idx)}`]}>
                      <span style={classes.tableColumnTitle}>{optionColumn.title}</span>
                      <span style={classes.tableColumnDesc}>{optionColumn.value}</span>
                    </Box>
                  );
                })}
              </Box>
            );
          })}
        </Box>
      </DialogContent>
      <Box sx={classes.dialogContentScanner}>
        <StaffOverrideCamera
          skipUserAccessCheck={skipUserAccessCheck}
          successOnMount={successOnMount}
          onSuccess={handleSuccess}
          badges={badges}
        />
      </Box>
    </Dialog>
  );
};

export default PaymentApproveDialog;
